import {configureStore} from "@reduxjs/toolkit"
import {condosRtkApi} from "@/api/condo"
import {propertiesRtkApi} from "@/api/properties"

export const store = configureStore({
   reducer: {
      [condosRtkApi.reducerPath]: condosRtkApi.reducer,
      [propertiesRtkApi.reducerPath]: propertiesRtkApi.reducer,
   },
   middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(condosRtkApi.middleware, propertiesRtkApi.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
